module.exports = __webpack_public_path__ + "6d7688d94d3ff4229e9df6d203464a12.jpg";